import React, {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';
import {useAuth} from '../../context/auth';
import {login, loginAPPLE} from '../../services/auth-service';
import {getIntendedUrl} from '../../modules/auth-persistor';
import {ErrorMessage, Field, Form, Formik} from "formik";
import MinimalLayout from "../../layouts/minimal";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {loginRequestSchema} from "../../utils/schemas";
import {useGlobalNotificationMessage} from "../../context/message";
import {AppRoutes, Links} from "../../utils/constants";
import AppleLogin from 'react-apple-login';
import FormGroup from "../../components/form-group";

export default function Login () {
  const auth = useAuth();
  const navigate = useNavigate();
  const {addErrorMessage, removeMessage } = useGlobalNotificationMessage();
  const [showForm, setShowForm] = useState(false);

  const handleSubmit = (values, { setSubmitting, setErrors }) => {
    removeMessage();
    login({
      login: values.email,
      password: values.password
    }).then((responseData) => {
      authCallback(responseData);
    }).catch(error => {
      if( error.response?.status===403 ){
        let msg = "Login failed. Please check your login details and try again. In case you forgot your password, try password recovery.";
        if (error.response?.data && error.response.data === 'Forbidden: You do not have permission to access this resource'){
          msg = `Your email address is not yet confirmed so we cannot log you in. Please confirm your email address via instructions sent into your email, or <a href="${AppRoutes.resendConfirmation.path}">resend confirmation email</a>.`;
        }
        if (error.response?.data && error.response.data !== 'Forbidden: You do not have permission to access this resource'){
          msg = error.response?.data;
        }
        HelperService.handleApiErrors(error, addErrorMessage, msg);
        return false;
      }
      HelperService.handleApiErrors(error, addErrorMessage);
      HelperService.handleFormErrors(error, setErrors);
    }).finally(()=>{setSubmitting(false);});
  };

  // const requestFBLimitedLogin = () => {
  //   window.FB.login(function(response) {
  //     handleFBLimitedLogin(response);
  //   }, { scope: 'email', auth_type: 'rerequest', enable_profile_selector: true });
  // };
  //
  // const handleFBLimitedLogin = (response) => {
  //   console.log(response);
  // };

  // const responseFacebook = (response) => {
  //   removeMessage();
  //   loginFB({
  //     token: response.accessToken
  //   }).then((responseData) => {
  //     authCallback(responseData);
  //   }).catch(error => {
  //     if( error.response?.status===403 ){
  //       let msg = "Login failed. Please check your login details and try again. In case you forgot your password, try password recovery.";
  //       if (error.response?.data && error.response.data === 'Forbidden: You do not have permission to access this resource'){
  //         msg = `Your email address is not yet confirmed so we cannot log you in. Please confirm your email address via instructions sent into your email, or <a href="${AppRoutes.resendConfirmation.path}">resend confirmation email</a>.`;
  //       }
  //       if (error.response?.data && error.response.data !== 'Forbidden: You do not have permission to access this resource'){
  //         msg = error.response?.data;
  //       }
  //       HelperService.handleApiErrors(error, addErrorMessage, msg);
  //       return false;
  //     }
  //     HelperService.handleApiErrors(error, addErrorMessage);
  //   });
  // }

  const responseApple = (response) => {
    if (response?.error?.error==='popup_closed_by_user'){
      return false;
    }
    HelperService.log(response);
    removeMessage();
    if (response.error){
      HelperService.handleApiErrors(response, addErrorMessage, response.error);
      return false;
    }

    loginAPPLE({
      token: response?.authorization?.id_token,
      name: response?.user?.name?.firstName,
      surname: response?.user?.name?.lastName,
      email: response?.user?.email,
    }).then((responseData) => {
      authCallback(responseData);
    }).catch(error => {
      if( error.response?.status===403 ){
        let msg = "Login failed. Please check your login details and try again. In case you forgot your password, try password recovery.";
        if (error.response?.data && error.response.data === 'Forbidden: You do not have permission to access this resource'){
          msg = `Your email address is not yet confirmed so we cannot log you in. Please confirm your email address via instructions sent into your email, or <a href="${AppRoutes.resendConfirmation.path}">resend confirmation email</a>.`;
        }
        if (error.response?.data && error.response.data !== 'Forbidden: You do not have permission to access this resource'){
          msg = error.response?.data;
        }
        HelperService.handleApiErrors(error, addErrorMessage, msg);
        return false;
      }
      HelperService.handleApiErrors(error, addErrorMessage);
    });
  }

  const authCallback = (responseData) => {
    if (!responseData?.bearer){
      throw new Error();
    }
    auth.setToken(responseData.bearer);
    auth.doAppUserLogin(responseData);
    if (!responseData.activated){
      navigate(AppRoutes.completeProfile.path)
    } else {
      getIntendedUrl() ? navigate(getIntendedUrl()) : navigate(AppRoutes.home.path);
    }
  }

  return (
      <>
        <Section animation={HelperService.getRandomAnimation()} className="bg-image">

          <div className="container">
            <div className="row justify-content-center align-items-center h100 py-5">
              <div className="col-xxl-4 col-lg-5">

                <div className="text-center pb-5">
                  <Link to={AppRoutes.landing.path}>
                    <span><img src="/assets/images/logo.svg" alt="" height="120"/></span>
                  </Link>
                </div>

                <div className="card">

                  {!showForm && <div className="card-body pt-5 px-4">

                    <div className={"text-center mb-4"}>
                      <button type="button" onClick={() => setShowForm(true)}
                              className="btn btn-outline-primary w-100"><span
                          className="mdi mdi-email me-2"></span> Sign in with e-mail
                      </button>
                    </div>

                    <div className={"mb-3 gap-2 d-flex align-items-center justify-content-center"}>
                      {/*<FacebookLogin*/}
                      {/*    appId={process.env.REACT_APP_FB_APP_ID}*/}
                      {/*    onSuccess={responseFacebook}*/}
                      {/*    onFail={responseFacebook}*/}
                      {/*    render={renderProps => (*/}
                      {/*        <button type="button" className="btn btn-fb btn-primary" title="Sign in with Facebook" onClick={renderProps.onClick}>*/}
                      {/*          <span className="mdi mdi-facebook"></span></button>*/}
                      {/*    )}*/}
                      {/*/>*/}
                      <AppleLogin clientId={process.env.REACT_APP_APPLE_BUNDLE}
                                  callback={responseApple}
                                  responseMode={"query"}
                                  resposeType={"id_token"}
                                  usePopup={true} //https://github.com/patelmayankce/react-apple-login/issues/50
                          // redirectURI={window.location.href}
                                  render={renderProps => (
                                      <button type="button" className="btn btn-apple btn-dark" title="Sign in with Apple" onClick={renderProps.onClick}>
                                        <span className="mdi mdi-apple"></span></button>
                                  )}
                      />
                    </div>

                  </div>}

                  {showForm && <div className="card-body p-4">

                    <div className="text-center w-75 m-auto">
                      <h4 className="text-dark-50 text-center pb-0 fw-bold">Sign in with e-mail</h4>
                      <p className="text-muted mb-4">Enter your email and password.</p>
                    </div>

                    <Formik
                        initialValues={loginRequestSchema.cast()}
                        validationSchema={loginRequestSchema}
                        onSubmit={handleSubmit}
                    >
                      {({isSubmitting, errors, touched}) => (
                          <Form>
                            <div className="mb-3">
                              <label htmlFor="email" className="form-label">E-mail</label>
                              <Field type="email" required
                                     name="email"
                                     placeholder="example@sweatnow.com"
                                     className={`form-control ${errors.email && touched.email ? "is-invalid" : ""}`}/>
                              <ErrorMessage name="email" component="div" className="invalid-feedback"/>
                            </div>
                            <FormGroup
                                name="password"
                                type="password"
                                autoComplete="current-password"
                                placeholder="********"
                                label="Password"
                                className="mb-3 col-12"
                                touched={touched} errors={errors}
                                schema={loginRequestSchema}
                            />
                            <div className={"text-center"}>
                              <button type="submit" className="btn btn-primary w-100"
                                      disabled={isSubmitting}>Confirm
                              </button>
                            </div>
                          </Form>
                      )}
                    </Formik>

                    <div className={"text-center pt-3"}>
                      <a href onClick={() => setShowForm(false)}
                         className="w-100 link-secondary clickable"><span className="mdi mdi-arrow-left"></span> back to
                        login methods
                      </a>
                    </div>

                  </div>}

                  <hr className={"mt-4 d-block"}/>

                  <div className="text-center">
                    Don't have an account? <Link to={AppRoutes.signup.path} className={"link-dark"}>Create new account.</Link>
                  </div>

                  <hr className={"mt-4 d-block"}/>

                  <p className="mb-4 text-center">
                    <Link to={AppRoutes.passwordRecovery.path} className={"link-dark"}>Forgotten password</Link>
                  </p>
                </div>

                <div className="text-center mt-3 fs-7 text-muted">By login up, signing up you agree to SweatNow's <a href={Links.terms} target="terms">Terms of Use</a></div>

              </div>
            </div>
          </div>
        </Section>
      </>
  );
}

Login.getLayout = function getLayout(page) {
  return (
      <MinimalLayout>
        {page}
      </MinimalLayout>
  )
}